

(function documentToDownloadV2 () {
   const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
   const compName = "document-to-download-v2";
   const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
   const Log = logFactory(`${compName}.js`);

    if (!isCompExists(compName, Log)) {
      return;
    }

   const ReadMore = GlobalSite.checkDependency('GlobalSite.readMore');
  const readMoreInstance = new ReadMore();
  const compSelector = GlobalSite.checkDependency('GlobalSite.getSelectorForComp')(
    compName,
  );
  const getCrDataForTable = GlobalSite.checkDependency('GlobalSite.getCrDataForTable');
  const getCrDataForTableDTS = GlobalSite.checkDependency('GlobalSite.getCrDataForTableDTS');
  const fippenConfig = {
    API_URL: '/fr/credit.fipenEditing.json',
    fipen: {
      pdfObject: window?.fipenDocs || undefined,
    },
    undefined: {
      pdfObject: undefined,
    },
  };
  document.cookie = 'axes=fr|PC|world|prof|PC|b84a28bce03d4eb59363e7bf9181c600|;path=/;';

  const createForm = ($root) => {
    $root.find('form').remove();
    const formTemplate = `<form action="${fippenConfig.API_URL}" target="_blank" method="POST">
      <input type="hidden" name="fipenData" value="">
    </form>`;
    $root.append(formTemplate);
    return $root.find('form');
  };



  $(() => {
    readMoreInstance.domHandler();

    $(`${compSelector} a.fipen`).on('click', async (e) => {
      e.preventDefault();
      let $target = $(e.target);
      if ($target[0].localName !== 'a') {
        $target = $target.parent();
      }
      const $parent = $target.parent();
      const targetId = $target.attr('fipen');

      if (!fippenConfig[targetId]?.pdfObject) {
        Log.error({ error: true, message: 'AEMFIPENOBJECT global variable not set from AEM' });
        return;
      }

      const $form = createForm($parent);
      const $input = $form.find('input[name="fipenData"]');
      $input.attr(
        'value',
        JSON.stringify(
           fippenConfig[targetId]?.pdfObject,
        ),
      );
      $form.submit();
    });
  });

    })()